import { useTranslation } from 'react-i18next'

type MoneyProps = {
  value: number
  className?: string
  currency?: string
  unit?: number
}

const Money = ({
  value,
  className = '',
  currency = 'CNY',
  unit = 1,
}: MoneyProps) => {
  const { t } = useTranslation()
  
  return (
    <>
      <span className={className + ' font-bold'}>
        {((value || 0) / unit).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      </span>
      &nbsp;
      <span>{t(`ecs.currency.${currency}`)}</span>
    </>
  )
}
export default Money
